// FinancialHealthScoreDetailsPDF.jsx
import { Font } from "@react-pdf/renderer";
import DejaVuSans from "../../../../../../assets/images/pdf/FHS_details/dejavu-lgc-fonts-ttf-2.37/ttf/DejaVuLGCSans.ttf";
import PoppinsRegular from "../../../../../../assets/images/pdf/FHS_details/Poppins/Poppins-Regular.ttf";
import PoppinsBold from "../../../../../../assets/images/pdf/FHS_details/Poppins/Poppins-Bold.ttf";
import PoppinsMedium from "../../../../../../assets/images/pdf/FHS_details/Poppins/Poppins-SemiBold.ttf";

import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import FHSGraph from "./FHSGraph";
import ForecastGraph from "./ForecastGraph";
import { BPM_KEY } from "../../../../../../utils/global";
import { Provider, useSelector } from "react-redux";
import SegmentInfluencingSection, {
  generateSegmentInfluencingData,
} from "./SegmentInfluencingSection";
import store from "../../../../../../app/store";
import exportimages from "../../../../../../assets/images/exportImages";
import AllSegmentsSection from "./AllSegmentsSection";
import InsightsAndRecommendation from "./InsightsAndRecommendation";
import {
  formatToDollar,
  getArrowIndicatorBase64Image,
  getDifferenceClassForFHS,
  getDifferencePropsForFHS,
  getDifferenceStyleForFHS,
} from "../../../../../../utils/Utils";
import { loadImageAsBase64 } from "./PDFUtils";

Font.register({
  family: "DejaVuSans",
  src: DejaVuSans,
});

Font.register({
  family: "Poppins",
  fonts: [
    { src: PoppinsRegular, fontWeight: 400 },
    { src: PoppinsBold, fontWeight: 700 },
  ],
});

export const PDFstyles = StyleSheet.create({
  normal: {
    fontFamily: "Poppins",
    fontWeight: 400,
  },
  bold: {
    fontFamily: "Poppins",
    fontWeight: 700,
  },
  semibold: {
    fontFamily: "Poppins",
    fontWeight: 600,
  },
  page: {
    padding: 30,
    fontSize: 10,
    lineHeight: 1.5,
    color: "#1a1a1a",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  headerSection: { margin: "30px 70px 10px 70px", minHeight: "210px" },
  title: {
    fontFamily: "Poppins",
    fontSize: "32px",
    fontWeight: "700",
    color: "#000",
    lineHeight: "46px",
  },
  subtitle: {
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: "500",
    marginTop: "10px",
  },
  formattedDate: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: "400",
    color: "#4b4b4b",
    marginBottom: "6px",
  },
  downloadPdfDesc: {
    fontFamily: "Poppins",
    fontSize: "9px",
    fontWeight: "400",
    lineHeight: "12px",
    color: "#868687",
  },
  insidePage: { padding: "32px 70px" },
  pageOneCard: {
    padding: "16px 20px 16px 20px",
    backgroundColor: "#F0F2FC",
    borderRadius: "6px",
    marginBottom: "16px",
    // height: "250px",
  },
  pageOneTitle: {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "100%",
    color: "#000",
    marginBottom: "20px",
  },
  pageOneCardTitle: {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "18px",
    color: "#000",
    marginBottom: "6px",
  },
  pageOneCardDesc: {
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: "400",
    lineHeight: "16px",
    color: "#494949",
  },
  cardContainer: {
    flexDirection: "column",
    gap: 10,
  },
  pageOneWhiteCard: {
    width: "48%", // This ensures two cards per row
    backgroundColor: "#fff",
    borderRadius: 6,
    padding: "16px",
    border: "1px solid #E4EFFF",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "158px",
  },
  pageOneCardSubTitle: {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "18px",
    color: "#181D27",
    marginBottom: "3px",
  },
  pageOneCardSubDesc: {
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: "400",
    lineHeight: "14px",
    color: "#4b4b4b",
    // marginBottom: "10px",
  },
  pageOneCardValues: {
    fontFamily: "Poppins",
    marginTop: "auto", // pushes this Text to the bottom
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "18px",
    color: "#000",
  },
  cohortAverage: {
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: "400",
    borderRadius: "4px",
    width: "100%",
    paddingVertical: 4,
    paddingHorizontal: 4,
    textAlign: "center",
  },
  pageFooter: {
    position: "absolute",
    bottom: 0,
    left: 50,
    right: 50,
    flexDirection: "row",
    justifyContent: "space-between",
    fontFamily: "Poppins",
    fontSize: "9px",
    fontWeight: "500",
    color: "#222",
    borderTop: "1px solid #E6E6FF",
    padding: "6px 20px 13px 20px",
  },
  pageNumber: {
    fontFamily: "Poppins",
    fontSize: "9px",
    fontWeight: "400",
    color: "#868687",
  },
  allSegmentContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "24px",
    backgroundColor: "#F8F8F8",
    borderRadius: "10px",
  },
  allSegmentCard: {
    padding: "16px",
    width: "50%", // leave room for spacing
    flexDirection: "column",
    position: "relative",
    height: "194px",
  },
  verticalSeparator: {
    width: 1,
    backgroundColor: "#ECECEC",
    height: "85%",
    alignSelf: "center",
  },
  icon: {
    padding: 8,
    backgroundColor: "#6c7de5",
    height: "36px",
    width: "36px",
    border: "2px solid #6c7de5",
    borderRadius: "6px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "8px",
  },
  segmentIcon: {
    padding: 8,
    backgroundColor: "#fff",
    height: "36px",
    width: "36px",
    border: "1px solid #BBC3F3",
    borderRadius: "6px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "8px",
  },
  logoImage: {
    width: "102px",
    height: "36px",
    marginBottom: "15px",
  },
  badgesRow: {
    flexDirection: "row",
    gap: 6,
  },
  badge: {
    fontFamily: "Poppins",
    fontSize: "11px",
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 4,
    paddingHorizontal: 6,
    paddingVertical: 3,
  },

  arrowIconContainer: {
    width: 40,
    height: 40, // ❗ Add height to properly center vertically
    display: "flex",
    flexDirection: "row", // default, but okay to include
    justifyContent: "center", // ⬇ Center vertically
    alignItems: "center", // ⬅ Center horizontally
  },
  arrowIcon: {
    width: 10,
    height: 10,
    marginRight: 4,
  },
  EWIPageTitle: {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "14px",
    color: "#676767",
    marginBottom: "12px",
  },
  EWItitle: {
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: "600",
    lineHeight: "26px",
    color: "#000",
  },
  EWICardData: {
    fontFamily: "Poppins",
    fontSize: "11px",
    fontWeight: "400",
    lineHeight: "18px",
    color: "#535862",
  },
  lightBlueCard: {
    backgroundColor: "#F0F7FF",
    borderRadius: "6px",
    padding: "24px 24px 12px 24px",
    marginBottom: "36px",
  },
});

export const cleanText = (text) => {
  if (!text) return text;

  let cleaned = text
    .normalize("NFKC")
    .replace(/\u00A0/g, " ")
    .replace(/[\uFFFD]/g, "")
    .replace(/[^\x20-\x7E\n]/g, "");

  // FIX malformed links like ((text](url))
  cleaned = cleaned.replace(
    /\(\(\s*([^\]]+)\]\(([^)]+)\)\s*\)\)/g,
    "([$1]($2))",
  );

  // Ensure space before '(' if missing
  cleaned = cleaned.replace(/([^\s])\(/g, "$1 (");

  return cleaned.trim();
};

const highlightTitles = ["recommendation", "expected outcome with autopilot"];

export const isHighlighted = (title) => {
  const normalized = cleanText(title).toLowerCase().trim();
  return highlightTitles.includes(normalized);
};

const FinancialHealthScoreDetailsPDF = ({
  orgName,
  selectedQuater,
  base64Chart,
  base64ChartNII,
  selectedbankMetrics,
  base64Logo,
  base64Banner,
  formattedDate,
  earlyWarningIndicatorsObjPdf,
  segmentInfluencingObjPdf,
  allSegmentDataObjPdf,
  regulatorySegmentsDataObjPdf,
  showAPValue,
}) => {
  const [segmentInfluencingObj, setSegmentInfluencingObj] = useState(
    segmentInfluencingObjPdf,
  );
  const [allSegments, setAllSegments] = useState(allSegmentDataObjPdf);

  const [EWIdataArr, setEWIdataArr] = useState(earlyWarningIndicatorsObjPdf);

  const [regulatorySegments, setRegulatorySegments] = useState(
    regulatorySegmentsDataObjPdf,
  );

  const icons = {
    green_upward_arrow: loadImageAsBase64(exportimages.green_upward_arrow),
    green_downward_arrow: loadImageAsBase64(exportimages.green_downward_arrow),
    orange_upward_arrow: loadImageAsBase64(exportimages.orange_upward_arrow),
    orange_downward_arrow: loadImageAsBase64(
      exportimages.orange_downward_arrow,
    ),
    red_upward_arrow: loadImageAsBase64(exportimages.red_upward_arrow),
    red_downward_arrow: loadImageAsBase64(exportimages.red_downward_arrow),
  };

  const chunkArray = (arr, size) =>
    Array.from({ length: Math.ceil(arr?.length / size) }, (_, i) =>
      arr?.slice(i * size, i * size + size),
    );

  const MainPage = ({ base64Logo, base64Banner, orgName, formattedDate }) => (
    <View>
      <View style={PDFstyles.headerSection}>
        {base64Logo && <Image src={base64Logo} style={PDFstyles.logoImage} />}
        {/* <Text style={PDFstyles.title}>Financial Health</Text>
        <Text style={PDFstyles.title}>Report</Text> */}
        <Text style={PDFstyles.title}>
          Financial Performance Benchmark Report &nbsp;
          <Text style={{ fontWeight: "normal" }}>|&nbsp;{selectedQuater}</Text>
        </Text>
        <Text style={PDFstyles.subtitle}>{orgName}</Text>
      </View>

      <View>{base64Banner && <Image src={base64Banner} />}</View>

      <View style={{ marginTop: 10, marginHorizontal: 70, marginBottom: 0 }}>
        <Text style={PDFstyles.formattedDate}>{formattedDate}</Text>
        <Text style={PDFstyles.downloadPdfDesc}>
          This report is for informational purposes only and is intended for the
          authorized recipient. {orgName} is not responsible for errors,
          omissions, or decisions based on this report. Unauthorized use or
          distribution is prohibited. For verification, contact sales@bond.ai
        </Text>
      </View>
    </View>
  );

  const FHSGuageChart = ({ base64Chart }) => (
    <View
      style={[
        PDFstyles.pageOneCard,
        {
          marginTop: "10px",
          maxWidth: "100%",
          width: "auto",
          height: "auto",
          objectFit: "cover",
        },
      ]}
    >
      {/* <Text style={PDFstyles.pageOneCardTitle}>Financial Health</Text> */}
      <Text style={PDFstyles.pageOneCardTitle}>
        Financial Performance Benchmark
      </Text>
      <Text style={PDFstyles.pageOneCardDesc}>
        Overall strength of your institution based on your financial performance
        as compare to your cohort.
      </Text>

      {base64Chart && (
        <Image
          src={base64Chart}
          style={{
            maxWidth: "100%",
            width: "auto",
            height: "auto",
            objectFit: "cover",
          }}
        />
      )}
    </View>
  );

  const NIIGraph = ({ base64ChartNII }) => (
    <View
      style={[
        PDFstyles.pageOneCard,
        {
          marginTop: "10px",
          // marginBottom: "80px",
          maxWidth: "100%",
          width: "auto",
          height: "auto",
          objectFit: "cover",
        },
      ]}
    >
      <Text style={PDFstyles.pageOneCardTitle}>
        Net Interest Income Forecast
      </Text>
      <Text style={PDFstyles.pageOneCardDesc}>
        Difference between interest revenues and interest expenses.
      </Text>
      {base64ChartNII && (
        <Image
          src={base64ChartNII}
          style={{
            maxWidth: "100%",
            width: "auto",
            height: "auto",
            objectFit: "cover",
          }}
        />
      )}
    </View>
  );

  const SegmentInfluence = ({ segmentInfluencingObj }) => (
    <View style={{ marginTop: "20px", marginBottom: "36px" }} wrap={false}>
      <Text
        style={[PDFstyles.pageOneCardTitle, { marginBottom: "16px" }]}
      >{`Institution Growth Forecast for ${
        selectedbankMetrics?.selectedBankMetricData?.forecast_quarter
      }`}</Text>
      <View style={PDFstyles.cardContainer}>
        {chunkArray(segmentInfluencingObj, 2)?.map((row, rowIndex) => {
          return (
            <View key={rowIndex} wrap={false}>
              {/* Render title only once, and only for the first block on the new page */}
              <View key={rowIndex} style={PDFstyles.row} wrap={false}>
                {row?.map((segment, colIndex) => {
                  const isForcasted_icon = getArrowIndicatorBase64Image(
                    "isForcasted",
                    showAPValue,
                    segment,
                  );

                  const isAPForcasted_icon = getArrowIndicatorBase64Image(
                    "isAPForcasted",
                    showAPValue,
                    segment,
                  );

                  return (
                    <View key={colIndex} style={PDFstyles.pageOneWhiteCard}>
                      {/* Top + Middle content wrapper */}
                      <View style={{ flexGrow: 1 }}>
                        {/* Top Content */}
                        <View
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                          }}
                        >
                          <View style={{ flex: 1 }}>
                            <Text style={PDFstyles.pageOneCardSubTitle}>
                              {segment?.title}
                            </Text>
                            <Text
                              style={[
                                PDFstyles.pageOneCardSubDesc,
                                { width: "75%" },
                              ]}
                            >
                              {segment?.description}
                            </Text>
                          </View>
                          <View style={[PDFstyles.icon, { marginLeft: 8 }]}>
                            <Image
                              src={segment?.base64Icon}
                              style={{ height: "17px", width: "18px" }}
                            />
                          </View>
                        </View>
                      </View>

                      {/* Bottom Content */}
                      <View style={{ marginTop: "10px" }}>
                        <Text style={PDFstyles.pageOneCardValues}>
                          {segment?.symbol === "$" && segment?.symbol}
                          {segment?.symbol === "$" &&
                            formatToDollar(segment.current)}
                          {segment?.symbol === "%" &&
                            Number(segment.value).toFixed(2)}
                          {segment?.symbol === "%" && segment?.symbol}
                        </Text>
                        <View
                          style={{
                            flexDirection: "row",
                            columnGap: 8,
                            position: "relative",
                          }}
                        >
                          {/* Forecasted Value */}
                          <View style={PDFstyles.badgesRow}>
                            <View
                              style={[
                                PDFstyles.badge,
                                {
                                  backgroundColor: "#E6E6E6",
                                },
                              ]}
                            >
                              {/* <Text>{isForcasted_icon}</Text> */}
                              {icons[isForcasted_icon] && (
                                <Image
                                  src={icons[isForcasted_icon]}
                                  style={PDFstyles.arrowIcon}
                                />
                              )}
                              <Text>
                                {segment?.symbol === "$" && segment?.symbol}
                                {segment?.symbol === "$" &&
                                  formatToDollar(segment.forecasted)}
                                {segment?.symbol === "%" &&
                                  Number(segment.ap_used).toFixed(2)}
                                {segment?.symbol === "%" && segment?.symbol}
                              </Text>
                            </View>
                          </View>

                          {/* AP Used Value */}
                          {showAPValue && (
                            <View style={PDFstyles.badgesRow}>
                              <View
                                style={[
                                  PDFstyles.badge,
                                  {
                                    backgroundColor: "#EBF3FE",
                                  },
                                ]}
                              >
                                {/* <Text>{isAPForcasted_icon}</Text> */}
                                {icons[isAPForcasted_icon] && (
                                  <Image
                                    src={icons[isAPForcasted_icon]}
                                    style={PDFstyles.arrowIcon}
                                  />
                                )}
                                <Text>
                                  {segment?.symbol === "$" && segment?.symbol}
                                  {segment?.symbol === "$" &&
                                    formatToDollar(segment?.final_AP_value)}
                                  {segment?.symbol === "%" &&
                                    Number(segment?.final_AP_value).toFixed(2)}
                                  {segment?.symbol === "%" && segment?.symbol}
                                </Text>
                              </View>
                            </View>
                          )}
                        </View>
                      </View>
                    </View>
                  );
                })}
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );

  const AllSegment = ({ allSegments }) => (
    <View style={{ marginBottom: 80 }}>
      <View>
        <Text
          style={PDFstyles.pageOneTitle}
        >{`Profitability & Risk Outlook for ${
          selectedbankMetrics?.selectedBankMetricData?.forecast_quarter
        }`}</Text>
      </View>

      {chunkArray(allSegments, 2)?.map((segmentRow, rowIndex) => (
        <View key={rowIndex} style={PDFstyles.allSegmentContainer} wrap={false}>
          {segmentRow?.map((segment, index) => {
            const isForcasted_icon = getArrowIndicatorBase64Image(
              "isForcasted",
              showAPValue,
              segment,
            );

            const isAPForcasted_icon = getArrowIndicatorBase64Image(
              "isAPForcasted",
              showAPValue,
              segment,
            );

            const isLeftCard = index === 0;
            const isRightCard = index === 1;

            const cardStyle = {
              ...PDFstyles.allSegmentCard,
            };

            return (
              <React.Fragment key={index}>
                <View
                  style={{
                    ...cardStyle,
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  {/* Top Section: Title + Description + Icon */}
                  <View>
                    <View style={PDFstyles.segmentIcon}>
                      <Image
                        src={segment?.base64Icon}
                        style={{ height: "18px", width: "17px" }}
                      />
                    </View>
                    <View>
                      <Text style={PDFstyles.pageOneCardSubTitle}>
                        {segment?.title}
                      </Text>
                      <Text style={PDFstyles.pageOneCardSubDesc}>
                        {segment?.description}
                      </Text>
                    </View>
                  </View>

                  {/* Bottom Section: Values */}
                  <View style={{ marginTop: 8 }}>
                    <Text style={PDFstyles.pageOneCardValues}>
                      {segment?.symbol === "$" && segment?.symbol}
                      {segment?.symbol === "$" &&
                        formatToDollar(segment?.current)}
                      {segment?.symbol === "%" &&
                      Number.isFinite(Number(segment?.current))
                        ? Number(segment?.current).toFixed(2)
                        : ""}
                      {segment?.symbol === "%" && segment?.symbol}
                    </Text>

                    <View
                      style={{
                        flexDirection: "row",
                        columnGap: 8,
                        position: "relative",
                      }}
                    >
                      <View style={PDFstyles.badgesRow}>
                        <View
                          style={[
                            PDFstyles.badge,
                            {
                              backgroundColor: "#E6E6E6",
                            },
                          ]}
                        >
                          {icons[isForcasted_icon] && (
                            <Image
                              src={icons[isForcasted_icon]}
                              style={PDFstyles.arrowIcon}
                            />
                          )}
                          <Text className="align-middle">
                            {segment?.symbol === "$" && segment?.symbol}
                            {segment?.symbol === "$" &&
                              formatToDollar(segment?.forecasted || 0)}
                            {segment?.symbol === "%" &&
                            Number.isFinite(Number(segment?.forecasted))
                              ? Number(segment?.forecasted).toFixed(2)
                              : ""}
                            {segment?.symbol === "%" && segment?.symbol}
                          </Text>
                        </View>
                      </View>
                      {showAPValue && (
                        <View style={PDFstyles.badgesRow}>
                          <View
                            style={[
                              PDFstyles.badge,
                              {
                                backgroundColor: "#EBF3FE",
                              },
                            ]}
                          >
                            {/* <Text>{isAPForcasted_icon}</Text> */}
                            {icons[isAPForcasted_icon] && (
                              <Image
                                src={icons[isAPForcasted_icon]}
                                style={PDFstyles.arrowIcon}
                              />
                            )}
                            <Text className="align-middle">
                              {segment?.symbol === "$" && segment?.symbol}
                              {segment?.symbol === "$" &&
                                formatToDollar(segment?.final_AP_value)}
                              {segment?.symbol === "%" &&
                              Number.isFinite(Number(segment?.final_AP_value))
                                ? Number(segment?.final_AP_value).toFixed(2)
                                : ""}
                              {segment?.symbol === "%" && segment?.symbol}
                            </Text>
                          </View>
                        </View>
                      )}
                    </View>
                  </View>
                </View>

                {/* Separator only between left and right card */}
                {isLeftCard && segmentRow?.length === 2 && (
                  <View style={PDFstyles.verticalSeparator} />
                )}
              </React.Fragment>
            );
          })}
        </View>
      ))}
    </View>
  );

  const RegulatorySegment = ({ regulatorySegments }) => (
    <View style={{ marginBottom: 80 }}>
      <View>
        <Text style={PDFstyles.pageOneTitle}>{`Additional Metrics for ${
          selectedbankMetrics?.selectedBankMetricData?.forecast_quarter
        }`}</Text>
      </View>

      {chunkArray(regulatorySegments, 2)?.map((segmentRow, rowIndex) => (
        <View key={rowIndex} style={PDFstyles.allSegmentContainer} wrap={false}>
          {segmentRow?.map((segment, index) => {
            const isForcasted_icon = getArrowIndicatorBase64Image(
              "isForcasted",
              showAPValue,
              segment,
            );

            const isAPForcasted_icon = getArrowIndicatorBase64Image(
              "isAPForcasted",
              showAPValue,
              segment,
            );
            const isLeftCard = index === 0;
            const isRightCard = index === 1;

            const cardStyle = {
              ...PDFstyles.allSegmentCard,
            };

            return (
              <React.Fragment key={index}>
                <View
                  style={{
                    ...cardStyle,
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  {/* Top Section: Title + Description + Icon */}
                  <View>
                    <View style={PDFstyles.segmentIcon}>
                      <Image
                        src={segment?.base64Icon}
                        style={{ height: "18px", width: "17px" }}
                      />
                    </View>
                    <View>
                      <Text style={PDFstyles.pageOneCardSubTitle}>
                        {segment?.title}
                      </Text>
                      <Text style={PDFstyles.pageOneCardSubDesc}>
                        {segment?.description}
                      </Text>
                    </View>
                  </View>

                  {/* Bottom Section: Values */}
                  <View style={{ marginTop: 8 }}>
                    <Text style={PDFstyles.pageOneCardValues}>
                      {segment?.symbol === "$" && segment?.symbol}
                      {segment?.symbol === "$" &&
                        formatToDollar(segment?.current)}
                      {segment?.symbol === "%" &&
                      Number.isFinite(Number(segment?.current))
                        ? Number(segment?.current).toFixed(2)
                        : ""}
                      {segment?.symbol === "%" && segment?.symbol}
                    </Text>

                    <View
                      style={{
                        flexDirection: "row",
                        columnGap: 8,
                        position: "relative",
                      }}
                    >
                      <View style={PDFstyles.badgesRow}>
                        <View
                          style={[
                            PDFstyles.badge,
                            { backgroundColor: "#E6E6E6" },
                          ]}
                        >
                          {/* <Text>{isForcasted_icon}</Text> */}
                          {icons[isForcasted_icon] && (
                            <Image
                              src={icons[isForcasted_icon]}
                              style={PDFstyles.arrowIcon}
                            />
                          )}
                          <Text className="align-middle">
                            {segment?.symbol === "$" && segment?.symbol}
                            {segment?.symbol === "$" &&
                              formatToDollar(segment?.forecasted || 0)}
                            {segment?.symbol === "%" &&
                            Number.isFinite(Number(segment?.forecasted))
                              ? Number(segment?.forecasted).toFixed(2)
                              : ""}
                            {segment?.symbol === "%" && segment?.symbol}
                          </Text>
                        </View>
                      </View>
                      {showAPValue && (
                        <View style={PDFstyles.badgesRow}>
                          <View
                            style={[
                              PDFstyles.badge,
                              {
                                backgroundColor: "#EBF3FE",
                              },
                            ]}
                          >
                            {/* <Text>{isAPForcasted_icon}</Text> */}
                            {icons[isAPForcasted_icon] && (
                              <Image
                                src={icons[isAPForcasted_icon]}
                                style={PDFstyles.arrowIcon}
                              />
                            )}
                            <Text className="align-middle">
                              {segment?.symbol === "$" && segment?.symbol}
                              {segment?.symbol === "$" &&
                                formatToDollar(segment?.final_AP_value)}
                              {segment?.symbol === "%" &&
                              Number.isFinite(Number(segment?.final_AP_value))
                                ? Number(segment?.final_AP_value).toFixed(2)
                                : ""}
                              {segment?.symbol === "%" && segment?.symbol}
                            </Text>
                          </View>
                        </View>
                      )}
                    </View>
                  </View>
                </View>

                {/* Separator only between left and right card */}
                {isLeftCard && segmentRow?.length === 2 && (
                  <View style={PDFstyles.verticalSeparator} />
                )}
              </React.Fragment>
            );
          })}
        </View>
      ))}
    </View>
  );

  const EWIData = ({ EWIdataArr }) => (
    <>
      {EWIdataArr?.map((row, rowIndex) => (
        <>
          <Page key={rowIndex} size="LETTER" style={PDFstyles.insidePage}>
            <View
              style={{
                // display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: "37px",
              }}
            >
              <View style={{ flex: 1 }}>
                <Text style={PDFstyles.EWIPageTitle}>Early Warning</Text>
                <Text style={PDFstyles.EWItitle}>{row.title_name}</Text>
              </View>
              <View>
                <Image
                  src={row?.base64Icon}
                  style={{ height: "82px", width: "82px" }}
                />
              </View>
            </View>

            {/* Problem, Rationale and Recommendation */}
            <EWI_data_In_LightBlueCard data={row} />

            <View fixed style={PDFstyles.pageFooter}>
              <Text>Autopilot</Text>
              <Text
                render={({ pageNumber }) =>
                  pageNumber < 10 ? `0${pageNumber}` : `${pageNumber}`
                }
                style={PDFstyles.pageNumber}
              />
            </View>
          </Page>

          {/* Detailed Action Plan */}
          <EWI_data_In_Action_Plan
            key={rowIndex}
            data={row}
            pageStyle={PDFstyles.insidePage}
            footerStyle={PDFstyles.pageFooter}
          />
        </>
      ))}
    </>
  );

  const SectionBlock = ({ title, items, icon }) => (
    <View
      style={[
        PDFstyles.lightBlueCard,
        {
          width: "100%", // FORCE FULL WIDTH
          alignSelf: "stretch",
        },
      ]}
    >
      {/* Header */}
      <View
        style={[
          {
            flexDirection: "row",
            alignItems: "center",
            width: "100%", // FULL WIDTH
            marginBottom: 12,
          },
          isHighlighted(title) && {
            backgroundColor: "#6C7DE5",
            paddingVertical: 8,
            paddingHorizontal: 12,
            borderRadius: 10,
          },
        ]}
      >
        {/* LEFT TEXT (takes all space) */}
        <Text
          style={[
            PDFstyles.pageOneCardSubTitle,
            {
              flexGrow: 1, // take remaining width
              marginBottom: 0,
              color: isHighlighted(title) ? "#fff" : "#181D27",
            },
          ]}
        >
          {cleanText(title)}
        </Text>

        {/* RIGHT ICON (fixed position) */}
        <Image
          src={icon}
          style={{
            width: 32,
            height: 32,
            marginLeft: 8, // spacing from text
            flexShrink: 0, //  don't shrink
          }}
        />
      </View>

      {/* Content */}
      {(Array.isArray(items) ? items : [items]).map((point, index) => {
        const text = cleanText(String(point).trim());

        // Split lines on <br>
        const lines = text.split(/<br\s*\/?>|<\/br>/gi);

        return (
          <View key={index} style={{ marginBottom: 8 }}>
            {lines.map((line, lineIndex) => {
              const trimmed = line.trim();

              const isBullet = trimmed.startsWith("- ");
              const cleanLine = isBullet
                ? trimmed.replace(/^-+\s*/, "")
                : trimmed;

              const parts = cleanLine.split(/(\*\*.*?\*\*)/g).filter(Boolean);

              return (
                <View
                  key={lineIndex}
                  style={{ flexDirection: "row", marginBottom: 2 }}
                >
                  {isBullet && <Text style={{ marginRight: 6 }}>•</Text>}

                  {/* ✅ Single Text wrapper */}
                  <Text style={PDFstyles.EWICardData}>
                    {parts.map((part, i) => {
                      const isBold =
                        part.startsWith("**") && part.endsWith("**");

                      const content = isBold
                        ? part.replace(/^\*\*|\*\*$/g, "")
                        : part;

                      return (
                        <Text
                          key={`${index}-${lineIndex}-${i}`}
                          style={{
                            fontFamily: "Poppins",
                            fontWeight: isBold ? 700 : 400,
                          }}
                        >
                          {cleanText(content)}
                        </Text>
                      );
                    })}
                  </Text>
                </View>
              );
            })}
          </View>
        );
      })}
    </View>
  );

  const EWI_data_In_LightBlueCard = ({ data }) => {
    if (!data.problem?.length) return null;

    return (
      <>
        <View wrap={false}>
          <SectionBlock
            title="Problem"
            items={data.problem_summary}
            icon={data.problem_icon}
          />
        </View>
        <View wrap={false}>
          <SectionBlock
            title="Consequence"
            items={data.rationale_summary}
            icon={data.rationale_icon}
          />
        </View>
        <View wrap={false}>
          <SectionBlock
            title="Recommendation"
            items={data.recommendation}
            icon={data.reccomendation_icon}
          />
        </View>
        <View wrap={false}>
          <SectionBlock
            title="Expected Outcome with Autopilot"
            items={data?.expected_outcome}
            icon={data.reccomendation_icon}
          />
        </View>
      </>
    );
  };

  const SectionBlockActionPlan = ({ title, items, icon }) => (
    <View style={[PDFstyles.lightBlueCard, { backgroundColor: "#F0F2FC" }]}>
      {/* Header */}
      <View
        style={{ flexDirection: "row", alignItems: "center", marginBottom: 16 }}
      >
        <View style={{ flex: 1 }}>
          <Text style={[PDFstyles.pageOneCardSubTitle, { marginBottom: 0 }]}>
            {title}
          </Text>
        </View>
        <Image src={icon} style={{ height: 32, width: 32 }} />
      </View>

      {/* Content */}
      {items?.map((point, index) => {
        const trimmed = String(point).trim();
        const isBullet = trimmed.startsWith("- ");
        const content = isBullet ? trimmed.slice(1).trim() : trimmed;

        const lines = content.split(/<br\s*\/?>|<\/br>/gi);

        return (
          <View key={index} style={{ flexDirection: "row", marginBottom: 12 }}>
            {isBullet && <Text style={{ marginRight: 6 }}>•</Text>}

            <Text style={{ ...PDFstyles.EWICardData, flex: 1 }}>
              {lines.map((line, lineIndex) => {
                const parts = line.split(/(\*\*.*?\*\*)/g);

                return parts.map((part, i) => {
                  const isBold = part.startsWith("**") && part.endsWith("**");

                  const text = isBold ? part.replace(/^\*\*|\*\*$/g, "") : part;

                  return (
                    <Text
                      key={`${index}-${lineIndex}-${i}`}
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: isBold ? 700 : 400,
                      }}
                    >
                      {cleanText(text)}
                      {/* add newline only at end of line */}
                      {i === parts.length - 1 && lineIndex < lines.length - 1
                        ? "\n"
                        : ""}
                    </Text>
                  );
                });
              })}
            </Text>
          </View>
        );
      })}
    </View>
  );

  const EWI_data_In_Action_Plan = ({ data, pageStyle, footerStyle }) => {
    if (!data) return null;

    return (
      <>
        {/* Page 1 */}
        <Page size="LETTER" style={pageStyle}>
          <Text style={[PDFstyles.pageOneCardSubTitle, { marginBottom: 13 }]}>
            Detailed Action Plan
          </Text>

          <SectionBlock
            title="Problem"
            items={data.problem}
            icon={data.problem_icon}
          />

          <View fixed style={footerStyle}>
            <Text>Autopilot</Text>
            <Text
              render={({ pageNumber }) =>
                pageNumber < 10 ? `0${pageNumber}` : `${pageNumber}`
              }
              style={PDFstyles.pageNumber}
            />
          </View>
        </Page>

        {/* Page 2 */}
        <Page size="LETTER" style={pageStyle}>
          <SectionBlock
            title="Consequence"
            items={data.rationale}
            icon={data.rationale_icon}
          />

          <View fixed style={footerStyle}>
            <Text>Autopilot</Text>
            <Text
              render={({ pageNumber }) =>
                pageNumber < 10 ? `0${pageNumber}` : `${pageNumber}`
              }
              style={PDFstyles.pageNumber}
            />
          </View>
        </Page>

        {/* Page 3 */}
        <Page size="LETTER" style={pageStyle}>
          <SectionBlockActionPlan
            title="Short-Term (0–6 months)"
            items={data.detailed_action_plan.short_term}
            icon={data.short_term_icon}
          />

          <View fixed style={footerStyle}>
            <Text>Autopilot</Text>
            <Text
              render={({ pageNumber }) =>
                pageNumber < 10 ? `0${pageNumber}` : `${pageNumber}`
              }
              style={PDFstyles.pageNumber}
            />
          </View>
        </Page>

        {/* Page 4 */}
        <Page size="LETTER" style={pageStyle}>
          <SectionBlockActionPlan
            title="Mid-Term (6–12 months)"
            items={data.detailed_action_plan.mid_term}
            icon={data.mid_term_icon}
          />

          <View fixed style={footerStyle}>
            <Text>Autopilot</Text>
            <Text
              render={({ pageNumber }) =>
                pageNumber < 10 ? `0${pageNumber}` : `${pageNumber}`
              }
              style={PDFstyles.pageNumber}
            />
          </View>
        </Page>

        {/* Page 5 */}
        <Page size="LETTER" style={pageStyle}>
          <SectionBlockActionPlan
            title="Long-Term (12+ months)"
            items={data.detailed_action_plan.long_term}
            icon={data.long_term_icon}
          />

          <View fixed style={footerStyle}>
            <Text>Autopilot</Text>
            <Text
              render={({ pageNumber }) =>
                pageNumber < 10 ? `0${pageNumber}` : `${pageNumber}`
              }
              style={PDFstyles.pageNumber}
            />
          </View>
        </Page>
      </>
    );
  };

  return (
    <Document>
      <Page size="LETTER">
        <MainPage
          base64Logo={base64Logo}
          base64Banner={base64Banner}
          orgName={orgName}
          formattedDate={formattedDate}
        />
      </Page>

      <Page size="LETTER" style={PDFstyles.insidePage}>
        <FHSGuageChart base64Chart={base64Chart} orgName={orgName} />

        <NIIGraph base64ChartNII={base64ChartNII} />

        <SegmentInfluence segmentInfluencingObj={segmentInfluencingObj} />

        <AllSegment allSegments={allSegments} />

        <View fixed style={PDFstyles.pageFooter}>
          <Text>Autopilot</Text>
          <Text
            render={({ pageNumber }) =>
              pageNumber < 10 ? `0${pageNumber}` : `${pageNumber}`
            }
            style={PDFstyles.pageNumber}
          />
        </View>
      </Page>

      <Page size="LETTER" style={PDFstyles.insidePage}>
        <RegulatorySegment regulatorySegments={regulatorySegments} />

        <View fixed style={PDFstyles.pageFooter}>
          <Text>Autopilot</Text>
          <Text
            render={({ pageNumber }) =>
              pageNumber < 10 ? `0${pageNumber}` : `${pageNumber}`
            }
            style={PDFstyles.pageNumber}
          />
        </View>
      </Page>

      <EWIData EWIdataArr={EWIdataArr} />
    </Document>
  );
};

export default FinancialHealthScoreDetailsPDF;
